import { useEffect, useState } from 'react';
// @mui
import { MenuItem, Stack } from '@mui/material';
// components
import Image from '../../../components/Image';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
// config
import { allLangs } from '../../../config';
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(null);
  const [selectecLang, setSelectedLang] = useState(0);

  const handleChangeLanguage = (lang) => {
    setOpen(null);
    i18n.changeLanguage(lang);
  };

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    const lang = allLangs.findIndex((lang) => lang.value === i18n.resolvedLanguage); // i18n.resolvedLanguage => return fallbackLng if language not found
    setSelectedLang(lang);
  }, [i18n.language]);

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          width: 40,
          height: 40,
          ...(open && { bgcolor: 'action.selected' }),
        }}
      >
        <Image disabledEffect src={allLangs[selectecLang].icon} alt={allLangs[selectecLang].label} sx={{ minWidth: 22}} />
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 180,
          '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
        }}
      >
        <Stack spacing={0.75}>
          {allLangs.map((option, index) => (
            <MenuItem key={option.value} onClick={() => handleChangeLanguage(option.value)}>
              <Image disabledEffect alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
